import { brandColors } from '@src/assets/colors/brandColors';
import SvgIconBulletList from '@src/assets/images/common/icon/editor/SvgIconBulletList';
import type { Editor } from '@tiptap/react';
import React from 'react';

import { handleBulletListToggle } from '../../../handlers/listHandlers';

interface BulletListButtonProps {
  editor: Editor;
  isActive: boolean;
  refreshActiveState: () => void;
}

export const BulletListButton: React.FC<BulletListButtonProps> = ({
  editor,
  isActive,
  refreshActiveState,
}) => {
  const activeHoverColor = brandColors['500'] || '#2B5CDD';
  const defaultIconColor = 'currentColor';

  return (
    <button
      onClick={() => handleBulletListToggle(editor, refreshActiveState)}
      className={`toolbar-button ${isActive ? 'active' : ''}`}
      title='箇条書き'
      type='button'
    >
      <SvgIconBulletList color={isActive ? activeHoverColor : defaultIconColor} />
    </button>
  );
};
